import { useState, useEffect, useRef } from 'react';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { ArticleMain } from '../../components/ArticleMain/ArticleMain';
import { ArticleWiki } from '../../pages/ArticleComponents/ArticleWiki'
import {
  ViewSwitch,
  DropDownSelector,
  InputDynamicWidth,
  usePagination,
  Tabs,
  ButtonBasic
} from '@lk-gtcom/ecomlab-components';
import Breadcrumb from '../ArticleComponents/ArticleTypesComponent/Breadcrumb/Breadcrumb';
import { RavshanArticlesHttps } from '../../fetchUrls';
import { BASE_ROUTE } from '../../App';
import customHeaders, { getSpace } from '../../common/headers';
import { useResetOnBaseURL } from '../../common/useResetOnBaseURL';
import { ModalMiltilevelSidebarSettings } from '../../components/Modal/ModalMiltilevelSidebarSettings/ModalMiltilevelSidebarSettings';
import useGeneralStore from '../../store/general';
import './Main.scss';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { ButtonWithIcon } from '../../components/Buttons/ButtonWithIcon/ButtonWithIcon';
import { Tooltip } from '../../components/TooltipV2/Tooltip';
import { usePushNotifications } from '../../common/pushNotification';
import { useResponseHandler } from '../../common/auth';

const SORT_DIRECTIONS = {
  ASC: 'ASC',
  DESC: 'DESC',
};

const SORTING_OPTIONS = [
  { label: 'По дате: сначала новые', headerField: 'date', direction: SORT_DIRECTIONS.DESC },
  { label: 'По дате: сначала старые', headerField: 'date', direction: SORT_DIRECTIONS.ASC },
  { label: 'По фамилии автора: От а до я', headerField: 'author', direction: SORT_DIRECTIONS.DESC },
  { label: 'По фамилии автора: От я до а', headerField: 'author', direction: SORT_DIRECTIONS.ASC },
  { label: 'По названию: От а до я', headerField: 'name', direction: SORT_DIRECTIONS.ASC },
  { label: 'По названию: От я до а', headerField: 'name', direction: SORT_DIRECTIONS.DESC },
];

const STATUS_OPTIONS = [
  { label: 'Active', value: 'active' },
  { label: 'Redact', value: 'redact' },
  { label: 'Update', value: 'update' },
];

const articleTabs = [
  { label: 'Статья', value: 'article' },
  { label: 'Настройка SEO', value: 'seo-setup' },
  { label: 'Проверка SEO', value: 'seo' },
  { label: 'Ключевики', value: '' },
  { label: 'Реклама', value: '' }
];

const getWikiIdFromUrl = () => {
  const path = window.location.pathname;
  const segments = path.split('/');
  const wikiId = segments[segments.length - 1]; // 'wiki-435'
  return wikiId.replace('wiki-', ''); // '435'
}

const Main = ({
  activeLang,
  pathBread,
  setCurrentArticle = () => { },
  currentArticle,
  pathsWebName,
  setPathsWebName,
  setDescription = () => { },
  paths,
  setPaths,
  directory = false,
  token = false,
  setToken = () => { },
  readonly = false,
  wikiId,
  isShowMain
}) => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const paginatorRef = useRef();
  const paginatorCallback2 = useRef();
  // Обработка ошибок
  const { addErrorPush, addSuccessPush } = usePushNotifications();
  const { handleTableResponse, handleRequestError } = useResponseHandler();
  const email = localStorage.getItem('email')
  const [currentWikiId, setCurrentWikiId] = useState(null)

  const [
    page,
    limit,
    total,
    setTotal,
    Paginator,
    resetPaginator,
    paginatorTransition
  ] = usePagination(paginatorCallback2.current, [], paginatorRef.current?.params);

  const navigate = useNavigate();
  const path = useParams()['*'];
  const [initialRender, setInitialRender] = useState(true);

  const [title, setTitle] = useState('')

  const [selectedTopLevelValue, setSelectedTopLevelValue] = useState(0);
  const [selectedEndLevelValue, setSelectedEndLevelValue] = useState(0);

  const [selectedTags, setSelectedTags] = useState([]);
  const [tags, setTags] = useState([]);
  const [total2, setTotal2] = useState(0);

  const [selectView, setSelectView] = useState('Tile-short');
  const [sidebarState, setSidebarState] = useState([]);

  const [sortingOption, setSortingOption] = useState(null);
  const sortingRef = useRef();
  const [search, setSearch] = useState('');

  const [selectedState, setSelectedState] = useState([]);
  const [isArticle, setIsArticle] = useState(false);

  const [pageValue, setPageValue] = useState('article')
  const [statusText, setStatusText] = useState("")

  const [isEditor, setIsEditor] = useState(false)
  const [isFavorite, setIsFavorite] = useState(false)
  const [isPin, setIsPin] = useState(false)

  // Крошки
  const [breadcrumbs, setBreadcrumbs] = useState([])

  // Проверка доступа для юзера при переходе по ссылке
  const fetchGetPermission = () => {

    let url = `https://portals.ecomru.ru/api/v2/article/wiki/permission?wiki_id=${currentWikiId}`

    fetch(url, { method: 'GET', headers })
      .then(res => {
        if (res.status === 403) {
          addErrorPush(`У вас нет прав для просмотра этого проекта wiki ID-${currentWikiId}`);
          navigate('/wiki/wiki-list')
          return;
        }
        if (res.ok) {
          return res.json()
        } else {
          throw new Error('bad response')
        }
      })
      .then(json => { })
      .catch(handleRequestError)
  }

  const fetchGetBreadcrumbs = (level_id, article_id) => {
    if (!level_id) {
      return
    }
    const level_id_params = level_id ? `?level_id=${level_id}` : ''
    const article_id_params = article_id ? `&article_id=${article_id}` : ''
    let url = `https://portals.ecomru.ru/api/v2/article/get_bread_crumbs${level_id_params}${article_id_params}`

    fetch(url, { method: 'GET', headers })
      .then(res => {
        if (res.ok) {
          return res.json()
        } else {
          setCurrentWikiId(getWikiIdFromUrl())
          throw new Error('bad response')
        }
      })
      .then(json => {
        setBreadcrumbs(json)
        if (json?.[0]?.value !== wikiId) {
          setCurrentWikiId(json?.[0]?.value || wikiId)
        }
      })
      .catch(handleRequestError)
  }

  const fetchSidebar = () => {
    setSidebarState([]);
    const url = `${RavshanArticlesHttps}/get_portals_by_lang`;

    const body = JSON.stringify({
      language: activeLang.toLowerCase(),
    });

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => {
        if (json?.length > 0) {
          setSidebarState((prev) => [...prev, ...json]);
        }
      })
      .catch(handleRequestError);
  };

  // Получение участников
  const fetchGetPossibleAttendees = (status = false) => {
    const url = ` https://portals.ecomru.ru/api/v2/article/wiki/wiki_participants?wiki_id=${currentWikiId}&can_be_add=${status}`;
    const newHeaders = {
      ...headers,
    };
    fetch(url, { headers: newHeaders })
      .then(handleTableResponse)
      .then((json) => {
        const editor_list = json.filter(({ can_change, login }) => ((login == email) && can_change))
        if (!readonly && editor_list?.length) setIsEditor(true)
      })
      .catch(handleRequestError);
  };

  useEffect(() => {
    fetchGetPermission()
  }, [currentWikiId]);

  useEffect(() => {
    fetchGetPossibleAttendees()
  }, [currentWikiId]);

  useResetOnBaseURL(BASE_ROUTE, () => {
    setSelectedEndLevelValue(0);
    setSelectedTopLevelValue(0);
  });

  useEffect(() => {
    if (initialRender) {
      fetchSidebar();
      setInitialRender(false);
    }
  }, []);

  useEffect(() => {
    setTotal(null);
    if (typeof +path?.at(-1) === 'number' && !isNaN(+path?.at(-1))) {
      setIsArticle(true);
    } else {
      setIsArticle(false);
    }
  }, [path]);

  const saveWidthColumn = () => {
    if (selectView == 'Table') {
      const colWidth = [...document.querySelectorAll('.col-th-border')];
      if (colWidth.length > 0) {
        const arrWidth = colWidth.map((el) =>
          el.style.width ? el.style.width : '247px'
        );
        sessionStorage.setItem('col-width', arrWidth);
      }
    }
  };

  useEffect(() => {
    saveWidthColumn();
  }, [selectedEndLevelValue]);


  const [selectedItemId, setSelectedItemId] = useState();

  // Логика переноса статьи на другой уровень
  const [dragArticle, setDragArticle] = useState(null)

  const onDragStartDropArticle = (e) => {
    setDragArticle(e)
  }

  const onDragOverDropArticle = (e) => {
    e.preventDefault()
  }

  return (
    <div className='article-main-container__breadcrumb-and-content'>
      <div className='article-main-container__breadcrumb-and-tabs'>

        <Breadcrumb
          isShowMain={isShowMain}
          breadcrumbs={breadcrumbs}
          setSelectedItemId={setSelectedItemId}
          setTitle={(e) => setTitle(e)}
          pathBread={pathBread}
          onPortalClick={(id) => {
            setSelectedTopLevelValue(id);
            setSelectedEndLevelValue(null);
          }}
        />

        {(path.includes('/article/') || path.includes('/new')) && <div className='article-and-tabs__top-panel'>
          {isEditor && <div className='article-and-tabs__tabs'>
            <Tabs
              tabs={articleTabs}
              stopRedirect
              pageValue={pageValue}
              setPageValue={e => setPageValue(e)}
            />
            <div style={{ minWidth: '230px' }}>
            </div>
          </div>}
        </div>}
      </div>



      <div className="article-main-container">
        <div className='article-main-container'>
          <ModalMiltilevelSidebarSettings
            readonly={!isEditor}
            directory={directory}
            breadcrumbs={breadcrumbs}
            fetchGetBreadcrumbs={fetchGetBreadcrumbs}
            setTitle={(e) => setTitle(e)}
            setPathsWebName={(e) => setPathsWebName(e)}
            onPortalClick={(id) => {
              setSelectedTopLevelValue(id);
              setSelectedEndLevelValue(null);
            }}
            onLevelClick={(id) => {
              setSelectedEndLevelValue(id);
              setSelectedTopLevelValue(null);
            }}
            setPaths={(e) => setPaths(e)}
            selectedItemId={selectedItemId}
            setSelectedItemId={setSelectedItemId}
            tokenWiki={token}
            pathBread={pathBread}
            setToken={setToken}
            dragArticle={dragArticle}
            setDragArticle={setDragArticle}
            wikiId={currentWikiId || wikiId}
            isSearching
          />


          <div className="flex">
            <div className="main-content">
              {
                (currentArticle && Object.keys(currentArticle)?.length > 0) ||

                ((path == 'level/sublevel/cpu/new') && (!path.includes('/article/') && (!path.includes('/articles/')))
                  ?
                  null
                  :
                  <div className="toolbar-info">
                    <TitlePage
                      title={title}
                    />

                    {path != 'articles/Вопрос-ответ' &&
                      path != 'articles' &&
                      !path.includes('article/') && (
                        <ViewSwitch
                          selectView={selectView}
                          setSelectView={(e) => setSelectView(e)}
                        />
                      )}
                  </div>
                )}

              {(!path?.includes('/article/') && !path?.includes('level/sublevel/cpu/new')) && (
                <div className="article-main__header">
                  <Tooltip
                    child={
                      <ButtonWithIcon
                        favorite
                        whiteGreen
                        size='m'
                        changeValue={isFavorite}
                        onClick={(e) => {
                          setIsFavorite(!isFavorite)
                        }}
                      />
                    }
                    text={!isFavorite ? 'Добавить в избранное' : 'Убрать из избранного'}
                  />

                  <Tooltip
                    child={
                      <ButtonWithIcon
                        pin
                        whiteGreen
                        size='m'
                        changeValue={isPin}
                        onClick={(e) => {
                          setIsPin(!isPin)
                        }}
                      />
                    }
                    text={!isPin ? 'Закрепить' : 'Убрать из закрепленных'}
                  />

                  {selectView !== 'Table' && (
                    <DropDownSelector
                      style={{ maxWidth: '360px' }}
                      isClearable={false}
                      options_prop={SORTING_OPTIONS.map((so) => ({
                        label: so.label,
                        value: {
                          headerField: so.headerField,
                          direction: so.direction,
                        },
                      }))}
                      state={sortingOption}
                      setState={(e) => {
                        setSortingOption(e);
                        sortingRef.current = {
                          param: e.value?.headerField,
                          direction: e.value?.direction,
                        };
                      }}
                      defaultValue={{
                        label: SORTING_OPTIONS[0].label,
                        value: {
                          param: SORTING_OPTIONS[0].headerField,
                          direction: SORTING_OPTIONS[0].direction,
                        },
                      }}
                    />
                  )}

                  <DropDownSelector
                    isClearable={false}
                    options_prop={STATUS_OPTIONS}
                    multi={false}
                    state={selectedState}
                    setState={(e) => setSelectedState(e)}
                    defaultValue={STATUS_OPTIONS[0]}
                  />

                  <InputDynamicWidth
                    onChange={(e) => setSearch(e)}
                    position="left"
                    maxWidth="100%"
                    drop={false}
                    isOpen={true}
                  />
                  {
                    selectedEndLevelValue || selectedTopLevelValue ?
                      (isEditor && <div className="toolbar-top">
                        <div className="new-article-btn">
                          <ButtonBasic
                            green
                            text='Новая статья'
                            width='auto'
                            disabled={!selectedItemId}
                            onClick={(e) => {
                              navigate(`./level/sublevel/cpu/new`);
                              setIsArticle(true)
                            }}
                          />
                        </div>
                      </div>)
                      :
                      null
                  }
                </div>
              )}


              <div
                className="article-main-container__content"
                style={{ overflow: selectView == 'Table' ? 'hidden' : 'visible' }}
              >

                <Routes>
                  {!isArticle && (
                    <Route
                      path={`/:level/:sublevel?/:sublevel2?/:sublevel3?/:sublevel4?/:sublevel5?`}
                      element={
                        <ArticleMain
                          isEditor={isEditor}
                          search={search}
                          fetchGetBreadcrumbs={fetchGetBreadcrumbs}
                          selectedState={selectedState}
                          sortingRef={sortingRef}
                          setSelectedTags={(e) => setSelectedTags(e)}
                          selectedTags={selectedTags}
                          setTags={(e) => setTags(e)}
                          activeLang={activeLang}
                          selectedEndLevelValue={selectedEndLevelValue}
                          selectedPortalValue={selectedTopLevelValue}
                          pathBread={pathBread}
                          selectView={selectView}
                          setTotalParent={setTotal2}
                          paths={paths}
                          setIsArticle={(e) => setIsArticle(e)}
                          setSelectedEndLevelValue={setSelectedEndLevelValue}
                          onDragStartDropArticle={onDragStartDropArticle}
                          onDragOverDropArticle={onDragOverDropArticle}
                          dragArticle={dragArticle}
                          isPin={isPin}
                          isFavorite={isFavorite}
                        />
                      }
                    />
                  )}

                  <Route
                    path={`/:level/:sublevel?/:sublevel2?/:sublevel3?/:sublevel4?/:sublevel5?/:cpu?/new`}
                    element={
                      <ArticleWiki
                        isEditor={isEditor}
                        isNew={true}
                        pathBread={pathBread}
                        activeLang={activeLang}
                        setCurrentArticle={setCurrentArticle}
                        setTags={(e) => setTags(e)}
                        tags={tags}
                        pathsWebName={pathsWebName}
                        setPathsWebName={(e) => setPathsWebName(e)}
                        setTitle={(e) => setTitle(e)}
                        setDescription={(e) => setDescription(e)}
                        selectedItemId={selectedItemId}
                        parent_id={
                          selectedEndLevelValue
                            ? selectedEndLevelValue
                            : selectedTopLevelValue
                        }
                        pageValue={pageValue}
                        setPageValue={setPageValue}
                        statusText={statusText}
                        setStatusText={setStatusText}
                        fetchGetBreadcrumbs={fetchGetBreadcrumbs}
                        setSelectedItemId={setSelectedItemId}
                      />
                    }
                  />

                  <Route
                    path="/:lang/:level/:cpu/:id"
                    element={
                      <ArticleWiki
                        isEditor={isEditor}
                        isNew={false}
                        activeLang={activeLang}
                        pathBread={pathBread}
                        setCurrentArticle={setCurrentArticle}
                        setTags={(e) => setTags(e)}
                        tags={tags}
                        setPaths={(e) => setPaths(e)}
                        pathsWebName={pathsWebName}
                        setPathsWebName={(e) => setPathsWebName(e)}
                        setTitle={(e) => setTitle(e)}
                        setDescription={(e) => setDescription(e)}
                        pageValue={pageValue}
                        setPageValue={setPageValue}
                        statusText={statusText}
                        setStatusText={setStatusText}
                        fetchGetBreadcrumbs={fetchGetBreadcrumbs}
                        setSelectedItemId={setSelectedItemId}
                      />
                    }
                  />

                  <Route
                    path="/:lang/:level/:id"
                    element={
                      <ArticleWiki
                        isEditor={isEditor}
                        isNew={false}
                        activeLang={activeLang}
                        pathBread={pathBread}
                        setCurrentArticle={setCurrentArticle}
                        setTags={(e) => setTags(e)}
                        tags={tags}
                        setPaths={(e) => setPaths(e)}
                        pathsWebName={pathsWebName}
                        setPathsWebName={(e) => setPathsWebName(e)}
                        setTitle={(e) => setTitle(e)}
                        setDescription={(e) => setDescription(e)}
                        pageValue={pageValue}
                        setPageValue={setPageValue}
                        statusText={statusText}
                        setStatusText={setStatusText}
                        fetchGetBreadcrumbs={fetchGetBreadcrumbs}
                        setSelectedItemId={setSelectedItemId}
                      />
                    }
                  />
                </Routes>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { Main };
